import React, { useState } from 'react';
import { ReactFlowProvider, useReactFlow } from 'reactflow';
import { FlashbarProps, Grid } from '@amzn/awsui-components-console';
import TaskDetailsPanel from 'src/components/selfServeWorkflows/executionView/taskDetailsPanel';
import ViewWorkflowExecutionPanel from 'src/components/selfServeWorkflows/executionView/workflowExecutionPanel';
import {
	Dependency,
	TaskDetails,
	TaskExecutionData,
} from 'src/@types/selfServeTypes/taskExecutionData.interface';
import { ListTaskExecutionsResponse } from 'src/@types/selfServeTypes/listTaskExecutions.interface';

export interface WorkflowExecutionCanvasProps {
	workflowId: string;
	workflowExecutionId: string;
	listTaskExecutionsResponse: ListTaskExecutionsResponse;
	nodeName: string;
	hasExecutePermissions: boolean;
	refreshView?: () => void;
	setFlashBarItems?: (items: FlashbarProps.MessageDefinition[]) => void;
}
function WorkflowExecutionCanvas({
	workflowId,
	workflowExecutionId,
	listTaskExecutionsResponse,
	nodeName,
	hasExecutePermissions,
	refreshView,
	setFlashBarItems,
}: WorkflowExecutionCanvasProps) {
	const [taskDetails, setTaskDetails] = React.useState({});
	const [showTaskDetails, setShowTaskDetails] = useState(false);
	const { fitView } = useReactFlow();

	const dependencies: Dependency[] =
		listTaskExecutionsResponse?.dependencies || [];
	const taskExecutions: TaskExecutionData[] =
		listTaskExecutionsResponse?.taskExecutions || [];

	const showTaskDetailsCallback = (taskDetails: TaskDetails = {}) => {
		setTaskDetails(taskDetails);
		setShowTaskDetails(Object.keys(taskDetails).length > 0);
		fitView();
	};

	return (
		<>
			<ReactFlowProvider>
				{
					<Grid
						gridDefinition={[
							{ colspan: showTaskDetails ? 8 : 12 },
							{ colspan: showTaskDetails ? 4 : 0 },
						]}
					>
						<ViewWorkflowExecutionPanel
							taskExecutions={taskExecutions}
							dependencies={dependencies}
							showTaskDetails={showTaskDetailsCallback}
						/>
						{showTaskDetails && (
							<TaskDetailsPanel
								taskDetails={{
									...taskDetails,
									workflowId,
									workflowExecutionId,
									nodeName,
								}}
								showTaskDetails={() => showTaskDetailsCallback()}
								refreshView={() => {
									showTaskDetailsCallback();
									refreshView&&refreshView();
								}}
								hasExecutePermissions={hasExecutePermissions}
								setFlashBarItems={setFlashBarItems}
							/>
						)}
					</Grid>
				}
			</ReactFlowProvider>
		</>
	);
}

export default WorkflowExecutionCanvas;
